import { createSlice ,createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchRangeThumbnailStore = createAsyncThunk("thumbnailStore/fetchRangeThumbnailStore",
  async (payload, thunkAPI) => {
    try {
     
      const response = await axios.post("/customAPIs/get_range");

      const range = response.data;
      //console.log(range)

      return range;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const defaultHierarchy = {
  searchDatabaseOptions: ["Active", "Archived"],
  searchModeOptions: ["un-verified", "verified"],
  projectOptions: [],
  loading: false,
  hierarchyData: {
    id: 'root',
    name: 'shelf viewer',
    type: "root",
    dataType: "root",
    children: [
      {
        id: "customer",
        name: "customer",
        type: "type",
        dataType: "customer",
        children: []
      },
      {
        id: "competition",
        name: "competition",
        type: "type",
        dataType: "competition",
        children: []
      }
    ]
  }
}

const defaultCursorDetails = {
  searchDatabase: "Active",
  searchMode: "un-verified",
  project: "",
  sd: "",
  ed: "",
  dataType: "",
  selectedType: "",
  selectedValue: "",
  currentKey: "",
  thumbnailDetails: [],
  lowerBound: 0,
  upperBound: 500,
  keys:[],
  lastThumbnailDetails:null,
  endOfThumbnailList: false
}

const parse_and_update = (arr, cursor_details, children) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].children.length > 0) {
      parse_and_update(arr[i].children, cursor_details, children)
    } else {
      if (
        (arr[i].name === cursor_details.selectedValue) &&
        (arr[i].dataType === cursor_details.dataType) &&
        (arr[i].type === cursor_details.selectedType)
      ) {
        arr[i].children = children
      }
    }
  }
}

export const Thumbnails = createSlice({
  name: "Thumbnails",
  initialState: {
    ...defaultHierarchy,
    cursorDetails: defaultCursorDetails,
    discardedThumbnails: []
  },
  reducers: {
    setProjectList(state,action){
     state.projectOptions=action.payload;
    },
    updateCursorDetails(state, action) {
      const params = action.payload;
      state.cursorDetails = params;
    },
    markAsDiscarded(state, action) {
      state.cursorDetails = {
        ...state.cursorDetails,
        thumbnailDetails: action.payload,
      }
    },
    markAsCorrect(state,action){
     state.cursorDetails={
      ...state.cursorDetails,
      discardedThumbnails:action.payload
     }
    },
    updateDiscardedThumbnails(state, action) {
      const thumbnails = state.cursorDetails.thumbnailDetails;
      const updatedThumbnails = thumbnails.filter(r => r.discarded !== true) ;
      state.cursorDetails.thumbnailDetails = updatedThumbnails;
    },
    updateHierarchyData(state, action) {
      const params = action.payload;
      let hierarchy = state.hierarchyData.children;
      parse_and_update(hierarchy, params.cursorDetails, params.children);

      state.hierarchyData.children = hierarchy;
      state.cursorDetails = params.cursorDetails;
    },
    updateAnnotatorConfig(state, action) {
      const {type, value} = action.payload;
      state["cursorDetails"][type] = value;
    },
    resetCursorDetails(state, action) {
     // console.log(action.payload);
      state.cursorDetails.dataType = "";
      state.cursorDetails.selectedType = "";
      state.cursorDetails.selectedValue = "";
      state.cursorDetails.currentKey = "";
      state.cursorDetails.thumbnailDetails = [];
      state.cursorDetails.lowerBound = action.payload.lowerBound;
      state.cursorDetails.upperBound =  action.payload.upperBound;
      state.cursorDetails.keys=[];
      state.cursorDetails.lastThumbnailDetails=null;
      state.cursorDetails.endOfThumbnailList=false
    },
    resetHierarchyData(state,action){
    state.hierarchyData.children[0].children=[];
    state.hierarchyData.children[1].children=[];
    },
    updateThumbnailDetailsAndKey(state,action){
      state.cursorDetails.thumbnailDetails=action.payload.thumbnailDetails;
      state.cursorDetails.currentKey=action.payload.currentKey;
      state.cursorDetails.lastThumbnailDetails=action.payload.lastThumbnailDetails
      state.cursorDetails.endOfThumbnailList=action.payload.endOfThumbnailList
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRangeThumbnailStore.pending, (state) => {
       //console.log("pending")
      })
      .addCase(fetchRangeThumbnailStore.fulfilled, (state, action) => {
        state.cursorDetails.lowerBound = action.payload.lowerBound;
        state.cursorDetails.upperBound = action.payload.upperBound;
        //console.log("fulfilled 2")
      })
      .addCase(fetchRangeThumbnailStore.rejected, (state, action) => {
       //console.log("rejected")
      });
  },
})